<template lang="pug">
    div
        v-toolbar( :color="colors.primary"
            dark
        )
            v-icon.mr-2 search
            h1.title Consulta de Precios - Buscador 
            v-progress-circular.loader(
                indeterminate
                v-if="loading"
            )
            div.mt-2.loader.d-flex(
                v-if="!loading && state===1"
            )
                span.pt-1 Exacta
                v-switch.mx-3(
                    v-model="fullMode"
                    )
                span.pt-1 Completa
        v-card.px-2.pt-4
            v-text-field(
                v-if="state === 1"
                ref="inp1"
                v-model="alias"
                :label="fullMode ? 'Nombre, código...' : 'Código Interno'"
                outline
                @blur="handleBlur('inp1')"
                @keydown="handleKeyDown($event)"
                @keydown.enter="fetchProducts"
                :disabled="loading"
                )
            AlterAutoComplete(
                :search-input="alias"
                ref="inp2"
                v-if="state === 2"
                :items="options"
                outline
                label="producto"
                return-object
                v-model="product"
                @change="selectProduct()"
                @blur="handleBlur('inp2')"
                @keydown="handleKeyDown($event)"
                @item:click="handleClick($event)"
                :disabled="loading"
            )
                //v-layout(slot="tail" slot-scope="props")
                    v-flex.xs6
                        span Stock: {{extractStock(props.item)}}
                    v-flex.xs6
                        span Precio: ${{extractPrice(props.item)}}
            span.px-2.subheading.green--text(
                v-show="state === 2"
            )
                v-icon.mr-2(color="green darken-3") info
                span {{options.length}} resultados encontrados
            v-layout.py-2.title(wrap v-if="state === 3")
                v-flex.xs8
                    span.mx-2 Producto: {{product.name}}
                v-flex.text-xs-right.xs2
                    span.mx-2 Precio: {{product.sale_price | mixFormatCurrency}}
                v-flex.text-xs-right.xs2
                    span Stock: {{formatNumber(product.stock)}}
            v-text-field(
                outline
                ref="inp3"                
                label="cantidad"
                v-model="quantity"
                @keydown="handleKeyDown($event)"
                @keydown.enter="emitProduct"
                @blur="handleBlur('inp3')"
                v-if="state === 3"
            )
            span.px-2.subheading.red--text(
                v-show="errorMessage"
            )
                v-icon.mr-2(color="red") error
                span Error: {{errorMessage}}
</template>

<script>
// -- Component Imports --
import AlterAutoComplete from '@/components/AlterAutoComplete/AlterAutoComplete.vue'
// -- JS Data files import --
// -- JS Libraries Import --
import ProductModel from '@/models/Warehouse/WhProduct'
import axios from 'axios'
// -- Mixins imports --
import InputValidations from '@/mixins/InputValidations'
import CurrencyUtils from '@/mixins/CurrencyUtils'
// -- Vuex Imports --
import { mapGetters } from 'vuex'
// -- Other Imports --
export default {
    name: 'internal-code-search-modal',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        // ------------------------- Component Data ---------------------------
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            loading: false,
            state: 1,
            // ------------------------ Data storing --------------------------
            alias: '',
            product: null,
            quantity: '',
            errorMessage: '',
            successMessage: '',
            options: [],
            fullMode: true,
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('input', val)
            },
        },
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
        ...mapGetters('AuthModule', { userOfficeID: 'branchOfficeID' }),
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        initialData() {
            return {
                loading: false,
                state: 1,
                alias: '',
                product: null,
                quantity: '',
                errorMessage: '',
                successMessage: '',
                options: [],
                fullMode: true,
            }
        },
        resetData() {
            Object.assign(this.$data, this.initialData())
        },
        // -------------------- Data fetching ---------------------------------
        fetchProducts() {
            this.successMessage = ''
            const limit = this.fullMode ? 3 : 1
            if (this.alias.length < limit) {
                this.errorMessage = `Deben ingresarse al menos ${limit} caractéres`
                return
            }
            this.errorMessage = ''
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/wh_product_slim_multiple_filter?search_string=${this.alias}`
            if (!this.fullMode) {
                route =
                    process.env.VUE_APP_API_ROUTE +
                    `/wh_product_slim_filter_alias_name?alias_name=${
                        this.alias
                    }`
            }
            let ms = 10000
            const timeout = new Promise((resolve, reject) => {
                let id = setTimeout(() => {
                    clearTimeout(id)
                    reject({
                        response: {
                            data: { message: 'tiempo de espera agotado' },
                        },
                    })
                }, ms)
            })
            let promise = axios.get(route)
            Promise.race([promise, timeout])
                .then(response => {
                    if (response.data.data.length > 1) {
                        this.options = response.data.data.map(itm => {
                            itm.text = `${itm.alias_name} - ${itm.name}`
                            if (itm.stock !== 0 && !itm.stock)
                                itm.stock = 'error'
                            return itm
                        })
                        this.state = 2
                        this.loading = false
                        // return response
                    } else if (response.data.data.length === 1) {
                        this.product = response.data.data[0]
                        this.selectProduct()
                    } else {
                        this.errorMessage = !this.fullMode
                            ? 'No se encontraron productos con este código'
                            : 'No se encontraron productos para esta búsqueda'
                        this.loading = false
                        this.$nextTick(() => this.$refs.inp1.focus())
                    }
                })
                .catch(e => {
                    if (e.response && e.response.data) {
                        let data = e.response.data
                        if (data.data) data = data.data
                        this.errorMessage = data.message
                    } else {
                        this.errorMessage = e
                    }
                    this.loading = false
                    this.handleBlur('inp1')
                })
        },
        selectProduct(id = this.product.id) {
            this.loading = true
            ProductModel.append('sale_prices', 'stocks', 'virtual_offer_price')
                .include('wh_product_upc_code', 'sl_wholesale_discounts')
                .where('is_salable', 'true')
                .find(id)
                .then(res => {
                    res.stock = this.extractWhStock(res)
                    if (res.upc_codes && res.upc_codes.length)
                        res.upc = res.upc_codes[0]
                    if (!res.stock || res.stock === 'err.') {
                        this.state = 1
                        this.errorMessage =
                            'Error de configuración del stock del producto'
                        this.loading = false
                        return
                    }
                    res.sale_price = this.extractSalePrice(res)
                    if (
                        !res.sale_price ||
                        res.sale_price === 'err.' ||
                        res.sale_price === 'no def.'
                    ) {
                        this.state = 1
                        this.errorMessage =
                            'Error de configuración del precio del producto'
                        this.loading = false
                        return
                    }
                    this.product = res
                    this.emitProduct()
                    /*
                    this.state = 3
                    this.loading = false
                    */
                })
                .catch(e => {
                    this.errorMessage = e.response.data.message
                    this.state = 2
                    this.loading = false
                })
        },
        // -------------------- Data handling and transformations -------------
        // addToCart() {
        //     let quantity = this.quantity || 1
        //     let product = this.product
        //     product.quantity = quantity
        //     // let items = [...this.items, product]
        //     let ver = true
        //     let items = this.items.map(itm => {
        //         if (itm.id === product.id) {
        //             itm.quantity =
        //                 parseInt(itm.quantity) + parseInt(product.quantity)
        //             ver = false
        //         }
        //         return itm
        //     })
        //     if (ver) items = [...items, product]
        //     this.setCartItems(items)
        //     let message = product.name
        //     this.resetData()
        //     this.successMessage = message
        // },
        emitProduct() {
            let quantity = this.quantity || 1
            let product = this.product
            product.quantity = quantity
            this.$emit('product', product)
            let message = product.name
            this.resetData()
            this.successMessage = message
        },
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        handleBlur(ref = 'inp1') {
            this.$nextTick(() => this.$refs[ref].focus())
        },
        handleKeyDown(e) {
            if (e.keyCode === 123) this._value = false
            if (e.keyCode === 112) {
                if (this.state === 1) return
                this.resetData()
            }
            if (e.keyCode === 113) {
                if (this.state > 1) return
                this.fullMode = !this.fullMode
            }
            if (e.keyCode === 114) {
                if (this.state > 1) return
                this.$emit('mode:multi')
                this._value = false
            }
        },
        handleClick(idx) {
            this.selectProduct(this.options[idx].id)
        },
        formatNumber(number, prefix = '') {
            if (isNaN(number)) number = parseFloat(number)
            let n = number
            n = parseFloat(n.toString())
            return prefix + this.mixCurrencyFormatter(n)
        },
        // -------------------- Vuex mappings ---------------------------------
        extractWhStock(item) {
            if (!item.stocks || !item.stocks.length) return 'err.'
            let err = null
            let officeStock = item.stocks
                .filter(s => s.g_branch_office_id === this.userOfficeID)
                .map(s => {
                    if (!s.wh_warehouses) {
                        err = true
                        return
                    }
                    let st = s.wh_warehouses.reduce((total, stk) => {
                        total += stk.logical_stock || 0
                        return total
                    }, 0)
                    return { stock: st }
                })
                .reduce((total, s) => {
                    total += s.stock
                    return total
                }, 0)
            if (err) return 'err.'
            officeStock = parseFloat(officeStock)
            return officeStock
            //return this.formatNumber(officeStock)
        },
        extractStock(item) {
            if (!item.stocks || !item.stocks.length) return 'err.'
            let officeStock = item.stocks
                .filter(s => s.g_branch_office_id === this.userOfficeID)
                .reduce((total, s) => {
                    total += s.stock
                    return total
                }, 0)
            return this.formatNumber(officeStock)
        },
        extractPrice(item) {
            if (!item.prices || !item.prices.length) return 'err.'
            let officePrice = item.prices.find(
                p => p.g_branch_office_id === this.userOfficeID
            )
            if (!officePrice || !officePrice.sale_price) return 'no def.'
            return this.formatNumber(officePrice.sale_price)
        },
        extractSalePrice(item) {
            if (!item.sale_prices || !item.sale_prices.length) return 'err.'
            let officePrice = item.sale_prices.find(
                p => p.branch_office_id === this.userOfficeID
            )
            if (!officePrice || !officePrice.sale_price) return 'no def.'
            return officePrice.sale_price
        },
        test(e) {
        },
    },
    watch: {
        value: {
            handler(val) {
                this.resetData()
                if (val) {
                    this.$nextTick(() => this.$refs.inp1.focus())
                } else {
                }
            },
            inmediate: true,
        },
        state: {
            handler(val) {
                this.$nextTick(() => this.$refs[`inp${val}`].focus())
            },
        },
        quantity: {
            handler(val, oldval) {
                this.$nextTick(
                    () => (this.quantity = this.mixWatchDecimal(val, oldval))
                )
            },
            immediate: true,
        },
    },
    components: {
        AlterAutoComplete,
    },
    mixins: [InputValidations, CurrencyUtils],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss">
.loader {
    position: absolute;
    right: 30px;
}
</style>
